export default __webpack_public_path__ + "static/media/arrow-down.17a76d7d.svg";